export default "__VITE_ASSET__GLuR8l9euBvDzzUiMJ3n1g__"